import { DeviceActions } from '@/app/platform/platform-data/actions/types';
import { Inject, Injectable } from '@angular/core';
import { AsyncResult } from '@common/result/asyncResult';
import { ErrorInformation } from '@shared/models/error/error-information';
import { DEVICE_SERVICE, DeviceService } from '@/app/platform/platform-data/services/types';
import { DeviceEntityStore } from '@/app/platform/platform-data/store/device.entity.store';
import { DeviceEntity } from '@/app/platform/platform-data/models/device.entity';

@Injectable({
  providedIn: 'root'
})
export class DeviceStoreActions implements DeviceActions {
  constructor(
    @Inject(DEVICE_SERVICE)
    private readonly deviceService: DeviceService,
    private readonly deviceStore: DeviceEntityStore
  ) {}

  async create(m: DeviceEntity): AsyncResult<DeviceEntity, ErrorInformation> {
    const result = await this.deviceService.create(m);
    result.ifSuccess(d => {
      this.deviceStore.add(d);
    });

    return result;
  }

  async delete(m: DeviceEntity): AsyncResult<DeviceEntity, ErrorInformation> {
    const result = await this.deviceService.delete(m);
    result.ifSuccess(d => {
      this.deviceStore.remove(d.id);
    });

    return result;
  }

  async loadAll(): AsyncResult<DeviceEntity[], ErrorInformation> {
    return await this.reloadAll();
  }

  async reloadAll(): AsyncResult<DeviceEntity[], ErrorInformation> {
    const result = await this.deviceService.getAll();
    result.ifSuccess(devices => {
      this.deviceStore.set(devices);
    });

    return result;
  }

  async update(m: DeviceEntity): AsyncResult<DeviceEntity, ErrorInformation> {
    const result = await this.deviceService.update(m);
    result.ifSuccess(d => {
      this.deviceStore.update(d.id, d);
    });

    return result;
  }

  reset(): void {
    this.deviceStore.reset();
  }
}
